import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import FilterTab from "../../../../../ReusableComponents/FilterDropDown/FilterTab";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function InsuranceCancellationList({
    token,
    titles = [],
    list = [],
    updateData,
}) {
    const [Popup, setPopUp] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [downloadLoadingTem, setDownloadLoadingTem] = useState(false);
    const [searchWords, setSearchWords] = useState([]);
    const [filter, setFiltered] = React.useState(list?.data);

    const dispatch = useDispatch();

    const {
        NoDataFound,
        Pagination,
        PaginationIndex,
        Search,
        CountPerPage,
        currentList,
    } = useSearchPagination(filter || []);

    const navigate = useNavigate();
    const apiCall = () => {
        updateData();
        // navigate(`/dashboard/fin-insurance/`);
    };

    function filterStatus(item) {
        if (item === "All") {
            setFiltered(list?.data);
            return;
        }
        setFiltered(list?.data.filter((emp) => emp.insurance_status === item));
    }

    useEffect(() => {
        setFiltered(list?.data);
    }, [list]);

    //edit text Field
    const downloadFile = async (url, fileName) => {
        try {
            const response = await nodeinstance.get(url, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                dispatch(
                    setAppError({
                        msg: "Excel Downloaded",
                        color: "success",
                    })
                );
                setDownloadLoadingTem(false);
                setDownloadLoading(false);
            } else {
                throw new Error("Something went wrong!");
            }
        } catch (err) {
            setDownloadLoading(false);
            dispatch(
                setAppError({
                    msg: err.message,
                })
            );
        }
    };
    return (
        <>
            <div className="pt-2 uppercase">
                <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
                    <button
                        className="p-2 px-4 rounded-md bg-black disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                        onClick={() => setPopUp(true)}
                    >
                        <p>UPDATE STATUS</p>
                        {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
                    </button>

                    <button
                        className="p-2 px-4 rounded-md bg-black disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                        onClick={() => {
                            downloadFile(
                                "/employee-insurance/downloadCancleData",
                                "Employee_Insurance_Template"
                            ),
                                setDownloadLoadingTem(false);
                        }}
                        disabled={downloadLoadingTem || list?.isLoading}
                    >
                        <p>DOWNLOAD CANCELLATION DATA TEMPLATE</p>
                        {downloadLoadingTem && <CgSpinner className="animate-spin" />}
                    </button>
                    <button
                        className="p-2 px-4 rounded-md bg-black disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                        onClick={() => {
                            downloadFile(
                                `/employee-insurance/downloadApplication`,
                                "INSURANCE_APPLICATION_DOWNLOAD"
                            );
                            setDownloadLoading(true);
                        }}
                        disabled={downloadLoading || list?.isLoading}
                    >
                        <p>DOWNLOAD
                            CANCELLATION APPLICATION</p>
                        {downloadLoading && <CgSpinner className="animate-spin" />}
                    </button>
                    <Search
                        searchKey={[
                            "employee_id",
                            "visa_reference_number",
                            "border_number",
                            "iqama_number",
                            "client_id",
                            "emp_id",
                            "sponsor_id",
                        ]}
                        setSearchWords={setSearchWords}
                    />
                </div>
                <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
                <CountPerPage />
                <div className="relative bg-white">
                    <div className="overflow-x-auto max-h-[70vh] ">
                        <div className="sticky top-0 z-10 bg-white min-w-[3400px]">
                            <div className="grid grid-cols-table-insurance-cencle gap-5 p-6 text-center">
                                {titles.map((t, index) => (
                                    <p key={index} className="font-semibold uppercase">
                                        {t}
                                    </p>
                                ))}
                            </div>
                        </div>
                        <div className="grid grid-cols-table-insurance-cencle gap-5 p-6 bg-white text-center">
                            {list?.isLoading && (
                                <LoadingWithLable className="col-span-full" />
                            )}
                            {!list?.isLoading && <NoDataFound />}
                            {!list?.isLoading &&
                                currentList.map((list, index) => (
                                    <React.Fragment key={index}>
                                        <PaginationIndex index={index} />
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.employee_name || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.effective_date || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.ineffective_date || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.nationality || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.emp_id || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.client_id || "-"}
                                            />
                                        </p>

                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.idnumber || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.newId || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.relation || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.gender || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.marital_status || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.class || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.mobile_number || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.sponsor_id || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.sponsor_id || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.membership_no || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.policy_no || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.insurance_co || "-"}
                                            />
                                        </p>
                                        <p>
                                            <Highlighter
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={list.status || "-"}
                                            />
                                        </p>


                                        <hr
                                            className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                                        />
                                    </React.Fragment>
                                ))}
                        </div>
                    </div>
                </div>
                <Pagination />
            </div>
            {Popup ? (
                <UploadFilePopUp
                    PopUp={Popup}
                    setPopUp={setPopUp}
                    title={"Upload Insurance Cancle Data"}
                    url={"/employee-insurance/uploadCancleData"}
                    callBack={apiCall}
                />
            ) : (
                ""
            )}
        </>
    );
}
